import { X } from '@griply/assets';
import React from 'react';
import { Button } from 'shared/components/ui/button';
import { Sizes } from 'shared/components/ui/button/types';
import { IconButton } from 'shared/components/ui/icon-button';
import {
  Colors as IconButtonColors,
  Sizes as IconButtonSizes,
} from 'shared/components/ui/icon-button/types';

import * as Styled from './connect-calendar-card.style';

export type ConnectCalendarCardProps = {
  title: string;
  subtitle: string;
  connectLabel: string;
  dismissLabel: string;
  onConnect: () => void;
  onDismiss: () => void;
};

export const ConnectCalendarCard: React.FC<ConnectCalendarCardProps> = ({
  title,
  subtitle,
  connectLabel,
  dismissLabel,
  onConnect,
  onDismiss,
}) => {
  return (
    <Styled.Container>
      <Styled.Text>
        <Styled.Title>{title}</Styled.Title>
        <Styled.Subtitle>{subtitle}</Styled.Subtitle>
      </Styled.Text>

      <Styled.Actions>
        <Button size={Sizes.Small} onClick={onConnect}>
          {connectLabel}
        </Button>

        <IconButton
          icon={X}
          size={IconButtonSizes.Small}
          color={IconButtonColors.Default}
          onClick={onDismiss}
          aria-label={dismissLabel}
        />
      </Styled.Actions>
    </Styled.Container>
  );
};
